let timer: ReturnType<typeof setTimeout> | null = null;
let lastCallArgs: any = null;

export default function dataLayerPush(data: {
  eventCallback?: () => void,
  eventTimeout?: number,
  [k: string]: any
}) {
  const cb = data.eventCallback;
  const timeout = typeof data.eventTimeout === 'number' ? data.eventTimeout : 500;
  let called = false;

  // safe wrapper for the callback
  function safeCallback() {
    if (!called) {
      called = true;
      try {
        if (cb) {
          cb();
        }
      } catch (e) {
        /* eslint-disable-next-line no-console */
        console.warn(e);
      }
    }
  }

  // if GTM looks alive, push into dataLayer with our wrapped CB
  if (
    data
    && Array.isArray(window.dataLayer)
    && window.dataLayer.find((el) => el['gtm.start'])
    && typeof window.dataLayer.push === 'function'
  ) {
    window.dataLayer.push({
      ...data,
      // overwrite the user callback with our wrapper
      eventCallback: safeCallback,
    });
  } else {
    // GTM isn’t ready or the push API is missing – call immediately
    safeCallback();
  }

  // fallback: if GTM never invokes our wrapper within `timeout` ms, fire it ourselves
  setTimeout(safeCallback, timeout);
}

export function delayedDataLayerPush(data: any) {
  lastCallArgs = data;
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    timer = null;
    dataLayerPush(lastCallArgs);
    lastCallArgs = null;
  }, 1000);
}
